import { cart, pubsub } from '@services';
import { parseHTML } from '@utils';

/**
 * Cart page threshold bar. Registers `fetch-cart-threshold-bar` for AJAX updates.
 * The drawer bar is rendered inside `line-items` and updates via `fetch-line-items` instead.
 */

class CartThresholdBar extends HTMLElement {
  #unsubscribers = [];

  static {
    cart.sections.push('fetch-cart-threshold-bar');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change', 'cart:clear'].map((event) =>
        pubsub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-threshold-bar']);
    const target = html.querySelector('[data-progress-bar]');
    this.replaceChildren(target || '');
  }
}

customElements.define('cart-threshold-bar', CartThresholdBar);
